export default __webpack_public_path__ + "static/media/Group9180.50b5d4fb.svg";